import React from "react";
import { MAT_PALETTE as C } from "../../../../styles/themes/mat-palette";

export type MatHeadState = "idle" | "thinking" | "greeting";

/**
 * Kanonischer «Mat»-Kopf als SVG-Fragment (ohne <svg>-Wrapper), damit sowohl
 * der kleine Avatar (mat-avatar.tsx) als auch die grössere Teaser-Figur
 * (MatFigure.tsx) dieselbe Geometrie nutzen. Koordinaten im 120x120-Viewport.
 */
export const MatHead: React.FC<{ stroke: string; visor: string; state: MatHeadState }> = ({ stroke, visor, state }) => (
    <g className="mat-head">
        <rect x="30" y="34" width="60" height="50" rx="12" fill={C.shell} stroke={stroke} strokeWidth="3" />
        <rect x="38" y="46" width="44" height="22" rx="11" fill={visor} />
        <g className="mat-eyes" data-state={state}>
            <rect x="45" y="52" width="11" height="11" rx="5.5" fill={C.mint} />
            <rect x="64" y="52" width="11" height="11" rx="5.5" fill={C.mint} />
            <circle cx="53" cy="55" r="1.6" fill={C.white} />
            <circle cx="72" cy="55" r="1.6" fill={C.white} />
        </g>
        {/* Antennen-Stummel (fester Stiel aus dem Kopf). */}
        <line x1="60" y1="34" x2="60" y2="26" stroke={stroke} strokeWidth="3" />
        {/* Rotes Kabel zwischen Stummel und Ball: verbindet beide sichtbar,
            damit der Ball beim «Pingen» (mat-antenna skaliert) nicht
            losgelöst wirkt. Liegt in der ping-Gruppe, dehnt sich also mit,
            und ist als eigenes Element vor dem Ball gezeichnet. */}
        <g className="mat-antenna">
            <line x1="60" y1="26" x2="60" y2="21" stroke={C.red} strokeWidth="2.4" strokeLinecap="round" />
            <circle cx="60" cy="21" r="4" fill={C.mint} />
        </g>
    </g>
);

export default MatHead;
